module.exports = __webpack_public_path__ + "img/gradient-12.6d0ca2c8.png";